import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/tool-coverage-and-gap')({
  beforeLoad: () => getTitleContextSlice('Tool Coverage and Gap'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
